import Link from 'next/link';
import { sharedLinkResolver } from 'remote-com-shared/domains/navigation/hrefResolver';

import {
  FooterContainer,
  Container,
  Link as LinkAnchor,
  Title,
  FooterInner,
  ColumnBody,
  Column,
  RemoteLogo,
  InstagramLogo,
  TwitterLogo,
  YoutubeLogo,
  LinkedinLogo,
  FooterWrapper,
  FooterBottom,
  Copyright,
  FooterIcons,
  SocialLink,
} from './styles';
import FacebookLogo from './styles/FacebookLogo';

const currentYear = new Date().getFullYear();

function FooterNavigationEntry(entry) {
  const { label, link } = entry;

  switch (link?.linkType) {
    case 'Link.document':
      return (
        <Link href={sharedLinkResolver(link)} passHref legacyBehavior>
          <LinkAnchor as="a">{label}</LinkAnchor>
        </Link>
      );
    case 'Link.web': {
      const { url, target } = link;
      return (
        <LinkAnchor as="a" href={url} target={target}>
          {label}
        </LinkAnchor>
      );
    }

    default:
      return null;
  }
}

function FooterNavigationColumnSlice({ primary, fields: menuEntries = [] }) {
  const { label } = primary;
  return (
    <FooterInner>
      <Column>
        <Title>{label}</Title>
        <ColumnBody>
          {menuEntries.map((entry, index) => (
            <FooterNavigationEntry {...entry} key={index} />
          ))}
        </ColumnBody>
      </Column>
    </FooterInner>
  );
}

function Footer({ primary = [] }) {
  return (
    <FooterContainer>
      <Container>
        <RemoteLogo />
        <FooterWrapper>
          {primary.map((slice, index) => (
            <FooterNavigationColumnSlice {...slice} key={index} />
          ))}
        </FooterWrapper>
      </Container>
      <FooterBottom>
        <Copyright>
          Copyright © {currentYear} Remote Technology, Inc. All rights reserved.
        </Copyright>
        <FooterIcons>
          <SocialLink
            href="https://www.youtube.com/channel/UCPJsrP8zyttajAybEMQBNgA"
            target="_blank"
            rel="noreferrer"
            aria-label="Visit Remote on YouTube"
          >
            <YoutubeLogo />
          </SocialLink>
          <SocialLink
            href="https://www.linkedin.com/company/remote.com"
            target="_blank"
            rel="noreferrer"
            aria-label="Visit Remote on LinkedIn"
          >
            <LinkedinLogo />
          </SocialLink>
          <SocialLink
            href="https://twitter.com/remote"
            target="_blank"
            rel="noreferrer"
            aria-label="Visit Remote on Twitter"
          >
            <TwitterLogo />
          </SocialLink>
          <SocialLink
            href="https://www.instagram.com/remote/"
            target="_blank"
            rel="noreferrer"
            aria-label="Visit Remote on Instagram"
          >
            <InstagramLogo />
          </SocialLink>
          <SocialLink
            href="https://www.facebook.com/remote/"
            target="_blank"
            rel="noreferrer"
            aria-label="Visit Remote on Facebook"
          >
            <FacebookLogo />
          </SocialLink>
        </FooterIcons>
      </FooterBottom>
    </FooterContainer>
  );
}

export default Footer;
